import React, { useState } from "react";
import { postData } from "../../../services/Axios/Axios";
import { Briefcase,  CircleX } from "lucide-react";
import { ApiUrl } from "../../../config/apiConfig";
import { showErrorToast, showSuccessToast } from "../../../utils/utils";
import PrimaryButton from "../../UIElements/PrimaryButton";

const inputClass =
    "w-full h-[32px] px-4 py-2 border placeholder:text-[13px] placeholder:text-gray-500 border-gray-400 mt-[2px] hover:border-gray-600 rounded-[5px] bg-gray-50 text-gray-800 font-normal focus:outline-none focus:ring-[1.5px] focus:ring-greenBg mb-1 focus:border-transparent transition-all duration-300 text-[13px]";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}

const CreateJobCategoryModal: React.FC<Props> = ({ isOpen, onClose, onSuccess }) => {
    const [categoryName, setCategoryName] = useState("");
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!categoryName.trim()) {
            showErrorToast("Category Name is required");
            return;
        }
        setLoading(true);
        try {
            await postData(ApiUrl.createJobCategory, { categoryName });
            onSuccess?.();
            setCategoryName("");
            onClose();
            showSuccessToast("Category added successfully!");
        } catch (e: any) {
            showErrorToast(e?.response?.data?.message ?? "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="w-full max-w-md rounded-xl bg-white shadow-xl animate-fadeIn flex flex-col">
                {/* HEADER */}
                <div
                    className="flex self-start gap-[10px] h-[45px] justify-between items-center text-white w-full 
          bg-gradient-to-r from-[#007070] via-[#06baba] to-[#007070] 
          bg-[length:200%_200%] animate-[gradient-x_4s_ease_infinite] 
          py-1 px-4 rounded-t-[8px] shadow-md"
                >
                    <div className="flex items-center space-x-2">
                        <Briefcase />
                        <h2 className="text-lg font-semibold text-white tracking-wide">
                            Add Job Category
                        </h2>
                    </div>
                    <CircleX
                        size={20}
                        className="bg-white text-greenBg rounded-full hover:p-1 cursor-pointer transition-all duration-500 hover:rotate-180 active:rotate-0"
                        onClick={onClose}
                    />
                </div>

                {/* BODY */}
                <div className="px-4 py-3">
                    <div className="grid grid-cols-1 gap-x-6 gap-y-2">
                        <div>
                            <label className="text-[#999999] text-[14px]">
                                Category Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                value={categoryName}
                                onChange={(e) => setCategoryName(e.target.value)}
                                className={inputClass}
                                placeholder="e.g. Dispatcher"

                                name="job-category-input-__ignore"
                                autoComplete="new-password"
                                readOnly
                                onFocus={(e) => e.currentTarget.removeAttribute("readonly")}

                                type="text"
                            />
                        </div>

                        <div className="flex justify-end mt-1">
                            <PrimaryButton
                                disabled={loading}
                                onClick={handleSubmit}
                                label="Save"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateJobCategoryModal;